import React from 'react'
import PropTypes from 'prop-types'
import Flickity from 'react-flickity-component'

class ImageSlider extends React.Component {
  constructor(props) {
    super(props)

    this.handleScroll = this.handleScroll.bind(this)
    this.loadImage = this.loadImage.bind(this)
    this.resizeFlickity = this.resizeFlickity.bind(this)
    this.observer = new IntersectionObserver(this.handleScroll, {
      root: null,
      threshold: 0.1,
    })
  }

  componentDidMount() {
    window.addEventListener('resize', this.resizeFlickity)

    this.flkty.on('ready', () => {
      const images = document.querySelectorAll('.dhsv-lazyload')

      Array.from(images).forEach(img => {
        this.observer.observe(img)
      })

      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('resize'))
      }, 1000)
    })
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resizeFlickity)
  }

  handleScroll(changes) {
    changes.forEach(change => {
      if (change.intersectionRatio > 0) {
        this.loadImage(change.target)
      }
    })
  }

  loadImage(image) {
    const src = image.dataset.srcset
    image.srcset = src
  }

  resizeFlickity() {
    if (window.innerWidth < 768) {
      const heights = this.flkty.slides.map(
        slide =>
          ((window.innerWidth - 60) /
            slide.cells[0].element.querySelector('img').naturalWidth) *
          slide.cells[0].element.querySelector('img').naturalHeight
      )
      const max =
        Math.max.apply(Math, heights) > 400
          ? 400
          : Math.max.apply(Math, heights)
      this.flkty.slider.style.height = max + 'px'

      this.flkty.option({ freeScroll: false })
      this.flkty.reloadCells()
    } else {
      this.flkty.option({ freeScroll: true })
      this.flkty.reloadCells()
    }
  }

  render() {
    const { slides, size } = this.props

    const flickityOptions = {
      cellSelector: '.slide',
      draggable: slides.length > 1 ? true : false,
      pageDots: false,
      prevNextButtons: true,
      contain: true,
      freeScroll: true,
      autoPlay: 5000,
      pauseAutoPlayOnHover: false,
      groupCells: true,
    }

    return (
      <div className={`dhsv_slider ${size}`}>
        <Flickity
          className={'flickity'}
          elementType={'div'}
          options={flickityOptions}
          disableImagesLoaded={false}
          reloadOnUpdate={true}
          flickityRef={c => (this.flkty = c)}
        >
          {slides.map((slide, i) => (
            <div data-src={slide.imagesrc} className="slide" key={i}>
              <div className="img-wrapper">
                <div dangerouslySetInnerHTML={{ __html: slide.image }} />
              </div>
            </div>
          ))}
        </Flickity>
      </div>
    )
  }
}

ImageSlider.propTypes = {
  slides: PropTypes.array.isRequired,
  size: PropTypes.string.isRequired,
}

export default ImageSlider
